//src/services/adminAbandonedCarts.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminAbandonedCarts = () => {
  return adminApiRequest("/admin/abandoned-carts");
};

// ✅ NEW
export const sendAbandonedCartEmail = (userId) => {
  return adminApiRequest(`/admin/abandoned-carts/${userId}/send-email`, {
    method: "POST",
  });
};

export const deleteAbandonedCart = (userId) => {
  return adminApiRequest(`/admin/abandoned-carts/${userId}`, {
    method: "DELETE",
  });
};

export const getAdminAbandonedCartByUserId = async (userId) => {
  const API_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5000/api";

  const token =
    localStorage.getItem("adminToken") ||
    localStorage.getItem("admin-token") ||
    localStorage.getItem("token");

  const res = await fetch(`${API_URL}/admin/abandoned-carts/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Failed to load abandoned cart");
  }

  return data;
};